import Modal from './modal';

export { ModalParent } from "./modalParent"
export default Modal;